const en_purch_quotationMitra = {

}

export default en_purch_quotationMitra;